module.exports = __webpack_public_path__ + "media/images/registrations/product_version/bg-05-8755227881fc239f53b68420ef398532.png";